import { useState, useEffect } from "react"
import Gauge from "./chart/Gauge";
import Line3 from "./chart/Line3";
import { Link } from "react-router-dom"
import Carousel from 'react-multi-carousel';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import Select from "react-select";
import Personal from "./Personal";

function BalanceOverview({user}) {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 1273, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1000, min: 740 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [allasset, setAllasset] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        type: 'crypto',
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
        label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
        value: coin.name,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
    fetch(`/fiat_list.txt`)
    .then((res) => res.json())
    .then((data) => {
      const wantedCurrencies = {
        AUD: 'Australian Dollar',
        CAD: 'Canadian Dollar',
        CHF: 'Swiss Franc',
        CNY: 'Chinese Yuan',
        EUR: 'Euro',
        GBP: 'British Pound',
        INR: 'Indian Rupee',
        JPY: 'Japanese Yen',
        RUB: 'Russian Ruble',
        USD: 'US Dollar',
        ZAR: 'South African Rand'
      };
      const fiatList = Object.entries(data)
        .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
        .map(([code, value], index) => ({
          id: index + 1,
          symbol: code,
          name: wantedCurrencies[code],
          price: Number(value),
          type: 'fiat',
          logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
          amount: 0,
        }));
      
      setFiat(fiatList);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const merged = [
      ...crypto,
      ...fiat,
      ...stock
    ];
    const methodop = [];
    merged.forEach(address => {
      methodop.push({
        value: address.name,
        logo: address.logo,
        label: (
          <>
            <img src={address.logo} alt={address.symbol} width="20" style={{ marginRight: 5 }} />
            {address.name}
          </>
        ),
        type: address.type,
        name: address.name,
        symbol: address.symbol,
        price: address.price
      });
    });
    setAllasset(methodop);
  }, [crypto, fiat, stock]);
  const [savingshistory, setSavingsHistory] = useState([]);
  const [distribution, setDistribution] = useState([]);
  const [allSavings, setAllSavings] = useState([]);
  const [loanData, setLoanData] = useState([]);
  const [countedLoan, setCountedLoan] = useState(0);
  const [activeloan, setActiveLoan] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);  
  const [totalProfit, setTotalProfit] = useState(0);
  const [savings30, setSavings30] = useState(0);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsavings: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.savings.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        const updatedSavings1 = data.all.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        setAllSavings(updatedSavings1);
        setSavingsHistory(updatedSavings);
        setDistribution(data.distribution);
        const amounts = updatedSavings.map(item => parseFloat(item.amountUSD) || 0);
        const total = amounts.reduce((sum, n) => sum + n, 0);
        setTotalSavings(total);
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchprofit: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.savings.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            amountUSD
          };
        });
        const amounts = updatedSavings.map(item => parseFloat(item.amountUSD) || 0);
        const total = amounts.reduce((sum, n) => sum + n, 0);
        setSavings30(total);
        //profit
        const updatedSavings1 = data.profit.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            amountUSD
          };
        });
        const amounts1 = updatedSavings1.map(item => parseFloat(item.amountUSD) || 0);
        const total1 = amounts1.reduce((sum, n) => sum + n, 0);
        setTotalProfit(total1);
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchloan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        //active loan
        const updatedLoan1 = data.activeloan.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let amountUSD = null;
          const asset = allasset.find(asset => asset.name === coinName);
          if (asset) {
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            amountUSD
          };
        });
        const amounts1 = updatedLoan1.map(item => parseFloat(item.amountUSD) || 0);
        const total1 = amounts1.reduce((sum, n) => sum + n, 0);
        setActiveLoan(total1);
        //counted loan
        const updatedLoan2 = data.countedloan.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let amountUSD = null;
          const asset = allasset.find(asset => asset.name === coinName);
          if (asset) {
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            amountUSD
          };
        });
        const amounts2 = updatedLoan2.map(item => parseFloat(item.amountUSD) || 0);
        const total2 = amounts2.reduce((sum, n) => sum + n, 0);
        setCountedLoan(total2);
        setLoanData(data.countedloan);
      }
    })
    .catch(err => {
    })
  }, [user, allasset]);
  const [chartData, setChartData] = useState({
    labels: [],
    data: []
  });
  const processLoanDataByMonth = (loans) => {
    const monthlyData = {};
    loans.forEach(loan => {
      const loanDate = new Date(loan.date);
      const monthKey = `${loanDate.getFullYear()}-${String(loanDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      const asset = allasset.find(asset => asset.name === loan.method);
      let price = 1;
      if (asset) {
        price = asset.price;
      }
      monthlyData[monthKey] += ((parseFloat(loan.amount.replace(/,/g, '')) * price) * rate);
    });
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] || 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  const formatMonth = (date) => {
    const options = { month: 'short' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };
  useEffect(() => {
    const { labels, data } = processLoanDataByMonth(loanData);
    setChartData({ labels, data });
  }, [loanData]);
  // Process savings data by month (fixed 8-month range)
  const processSavingsDataByMonth = (savings) => {
    const monthlyData = {};
    savings.forEach(saving => {
      const savingDate = new Date(saving.date);
      const monthKey = `${savingDate.getFullYear()}-${String(savingDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      monthlyData[monthKey] += parseFloat(saving.amountUSD);
    });  
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] || 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  const [savingsChartData, setSavingsChartData] = useState({ labels: [], data: [] });
  useEffect(() => {
    const { labels, data } = processSavingsDataByMonth(savingshistory);
    setSavingsChartData({ labels, data });
  }, [savingshistory]);
  // Process distribution data by month (fixed 8-month range)
  const processDistributionDataByMonth = (distributions) => {
    const monthlyData = {};
    distributions.forEach(distribution => {
      const distributionDate = new Date(distribution.date);
      const monthKey = `${distributionDate.getFullYear()}-${String(distributionDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      monthlyData[monthKey] += parseFloat(distribution.amount.replace(/,/g, ''));
    });
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] || 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  const [distributionChartData, setDistributionChartData] = useState({ labels: [], data: [] });
  useEffect(() => {
    const { labels, data } = processDistributionDataByMonth(distribution);
    setDistributionChartData({ labels, data });
  }, [distribution]);
  const [loading, setLoading] = useState(false);
  const [personalBar, setPersonalBar] = useState(false);
  const togglePersonalBar = () => {
    setPersonalBar(!personalBar);
  };

  return (
    <div className="row">
      <div className="col-lg-5 col-md-6">
        <div className="mycard mt-2 position-relative overflow-hidden">
          <img src={require(`../images/map_1.png`)} alt="chart" className="position-absolute" style={{height:'400px', right:'-15%', top:'-15%',zIndex:'1'}}/>
          <div className="position-relative" style={{zIndex:'2'}}>
            <p className="mb-0 fw-semibold mb-3" style={{color:'gray'}}>Balance Overview</p>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div className="mb-4 mb-md-0">
                <h4 className="mb-0 fw-bold text-prime">{getCurrencySymbol(user?.currency)}{formatCurrency(user?.savings * rate)}</h4>
                <p className="mb-0 fw-semibold" style={{color:'gray',fontSize:'15px'}}>Total Balance</p>
                <h4 className="mb-0 fw-bold text-white mt-3">{getCurrencySymbol(user?.currency)}{formatCurrency(user?.vested_savings * rate)}</h4>
                <p className="mb-0 fw-semibold" style={{color:'gray',fontSize:'15px'}}>Vested Balance</p>
              </div>
              <div style={{width:'2px',height:'100px',backgroundColor:'#242424'}}></div>
              <div>
                <h5 className="mb-0 fw-bold text-success">+{getCurrencySymbol(user?.currency)}{formatCurrency(user?.savings_gain * rate)}</h5>
                <p className="mb-0 fw-semibold" style={{color:'gray',fontSize:'15px'}}>Your Investment Gain</p>
                <h5 className="mb-0 fw-bold text-white mt-4">{formatCurrency(user?.savings_rate)}%</h5>
                <p className="mb-0 fw-semibold" style={{color:'gray',fontSize:'15px'}}>Contribution Rate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-6 pe-0 pe-md-2">
        <div class="mycard mt-2 position-relative overflow-hidden p-2 p-md-4">
          <img src={require(`../images/background-icon.png`)} alt="chart" className="position-absolute" style={{height:'280px', right:'-15%', top:'0%', zIndex:'1'}}/>
          <div className="position-relative" style={{zIndex:'2'}}>
            <p className="mb-0 fw-semibold mb-3" style={{color:'gray'}}>Last Contribution</p>
            <h2 className="mb-0 fw-bold text-prime text-center">+{getCurrencySymbol(user?.currency)}{formatCurrency(totalSavings * rate)}</h2>
            <p className="mb-0 fw-semibold text-center mb-3" style={{color:'gray',fontSize:'15px'}}>Total Contribution</p>
            {savingshistory.length >= 2 && (
              <>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">{savingshistory[savingshistory.length - 1].description}</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(savingshistory[savingshistory.length - 1].amountUSD * rate)}</p>
                </div>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">{savingshistory[savingshistory.length - 2].description}</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(savingshistory[savingshistory.length - 2].amountUSD * rate)}</p>
                </div>
              </>
            )}
            {savingshistory.length == 1  && (
              <>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">{savingshistory[savingshistory.length - 1].description}</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white text-nowrap">{getCurrencySymbol(user?.currency)}{formatCurrency(savingshistory[savingshistory.length - 1].amountUSD * rate)}</p>
                </div>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">--</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white text-nowrap">$--</p>
                </div>
              </>
            )}
            {savingshistory.length == 0 && (
              <>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">--</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white text-nowrap">$--</p>
                </div>
                <div className="d-flex align-items-end justify-content-between">
                  <p className="mb-0 fw-semibold text-white text-nowrap">--</p>
                  <div style={{width:'100%',maxWidth:'350px',borderTop:'2px dotted #242424',marginBottom:'5px'}}></div>
                  <p className="mb-0 fw-semibold text-white text-nowrap">$--</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-6 ">
        <div class="mycard mt-2 position-relative overflow-hidden p-2 p-md-4">
          <img src={require(`../images/background-icon2.png`)} alt="chart" className="position-absolute" style={{height:'230px', right:'-15%', top:'0%', zIndex:'1'}}/>
          <div className="d-flex flex-column align-items-center position-relative" style={{zIndex:'2'}}>
            <img src={require(`../images/savings.png`)} alt="chart" style={{maxWidth: '130px',width:'100%'}}/>
            <p className="mb-0 text-center text-success fw-semibold" style={{maxWidth: '200px',lineHeight:'100%'}}>You’re getting your full employer match.</p>
          </div>
        </div>
      </div>
      <div className="col-xxl-3 col-lg-5 col-md-6">
        <div className="mycard mt-2 pt-3 pb-2">
          <div className="row">
            <div className="col-4 px-2">
              <Link to="/contributions" className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/price-tag.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw-semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Contribution Rate</p>
              </Link>
            </div>
            <div className="col-4 px-2">
              <Link to="/deposit" state={{route : '401k'}} className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/growth.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw  -semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Add to Savings</p>
              </Link>
            </div>
            <div className="col-4 px-2">
              <Link to="/portfolio" className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/profile.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw-semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Portfolio</p>
              </Link>
            </div>
            <div className="col-4 px-2">
              <Link to="/loan" className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/swap.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw-semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Rollover Loan</p>
              </Link>
            </div>
            <div className="col-4 px-2">
              <Link to="/loan" className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/bank.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw-semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Borrow / Loan</p>
              </Link>
            </div>
            <div className="col-4 px-2">
              <Link to="/retirement" className="glozzy rounded-3 p-2 d-flex flex-column align-items-center mb-2 noLink" style={{cursor:'pointer', minHeight:'90px'}}>
                <img className="mb-2 " src={require(`../images/money-bags.png`)} alt="chart" style={{width:'30px'}}/>
                <p className="text-center mb-0 fw-semibold text-white" style={{lineHeight:'120%',fontSize:'14px'}}>Investment Plan</p>
              </Link>
            </div>
          </div> 
        </div>
      </div>
      <div className="col-xxl-2 col-lg-3 col-md-6">
        <div class="mycard mt-2 position-relative overflow-hidden">
          <img src={require(`../images/background-icon1.png`)} alt="chart" className="position-absolute" style={{height:'150px', right:'-15%', top:'-10%',zIndex:'1'}}/>
          <div className="position-relative" style={{zIndex:'2'}}>
            <p className="fw-semibold text-secondary mb-3">Earn</p>
            <p className="h2 mb-0">{getCurrencySymbol(user?.currency)}{formatCurrency(totalSavings * rate)}</p>
            <p className="fw-semibold text-secondary mb-0" style={{fontSize:'14px'}}>Total deposit value</p>
            <div className="d-flex align-items-end mt-4" style={{gap:'30px'}}>
              <div>
                <p className="h4 mb-0">{getCurrencySymbol(user?.currency)}{formatCurrency(totalProfit * rate)}</p>
                <p className="fw-semibold text-secondary mb-0" style={{fontSize:'14px'}}>30-Days Profit</p>
              </div>
              <p className="status-success">{formatCurrency((savings30 == 0)?0:(totalProfit/savings30) * 100)}%</p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-2 col-lg-3 col-md-6">
        <div class="mycard mt-2 position-relative overflow-hidden">
          <img src={require(`../images/background-icon1.png`)} alt="chart" className="position-absolute" style={{height:'150px', right:'-15%', top:'-10%',zIndex:'1'}}/>
          <div className="position-relative" style={{zIndex:'2'}}>
            <p className="fw-semibold text-secondary mb-3">Loan</p>
            <p className="h2 mb-0">{getCurrencySymbol(user?.currency)}{formatCurrency(countedLoan * rate)}</p>
            <p className="fw-semibold text-secondary mb-0" style={{fontSize:'14px'}}>Total loan amount</p>
            <div className="d-flex align-items-end mt-4" style={{gap:'30px'}}>
              <div>
                <p className="h4 mb-0">{getCurrencySymbol(user?.currency)}{formatCurrency(activeloan * rate)}</p>
                <p className="fw-semibold text-secondary mb-0" tyle={{fontSize:'14px'}}>Liability</p>
              </div>
              <div className="position-absolute" style={{bottom:'-20px',right:'-20px',zIndex:'1',height:'100px',width:'100px'}}>
                <Gauge range={activeloan == 0?0:(activeloan/countedLoan) * 100} height="50"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-5">
        <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
          <Carousel responsive={responsive}
            swipeable={true}
            draggable={true}
            showDots={false}
            ssr={true}
            infinite={true}
            autoPlay={true}
            keyBoardControl={true}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
          >
            <div className="mycard position-relative overflow-hidden">
              <div className="position-relative" style={{zIndex:'2'}}>
                <p className="h3 mb-0 mb-1">Build retirement</p>
                <p className="px-2 h3 mb-0 bg-white text-black d-inline-block">with crypto & stocks</p>
                <p className="h4 mb-0 mb-0">for the long term</p>
              </div>
              <img src={require(`../images/pngegg354.png`)} alt="chart" style={{maxWidth: '300px',width:'100%', bottom:'-50px', right:'-50px'}} className="position-absolute"/>
            </div>
            <div className="mycard position-relative overflow-hidden">
              <div className="position-relative" style={{zIndex:'2'}}>
                <p className="h3 mb-0 mb-1">Earn up</p>
                <p className="px-2 h3 mb-0 bg-white text-black d-inline-block">to 10% APY</p>
                <p className="h4 mb-0 mb-0">just by holding</p>
              </div>
              <img src={require(`../images/pngegg.png`)} alt="chart" style={{maxWidth: '500px',width:'100%', bottom:'-50px', right:'-50px',zIndex:'1'}} className="position-absolute"/>
            </div>
            <div className="mycard position-relative overflow-hidden">
              <div className="position-relative" style={{zIndex:'2'}}>
                <p className="h3 mb-0 mb-1">Access cash</p>
                <p className="px-2 h3 mb-0 bg-white text-black d-inline-block">using your holdings</p>
                <p className="h4 mb-0 mb-0">keep the upside</p>
              </div>
              <img src={require(`../images/pngegg654.png`)} alt="chart" style={{maxWidth: '350px',width:'100%', bottom:'-50px', right:'-50px'}} className="position-absolute"/>
            </div>
          </Carousel>
        </div>
      </div>
      <div className="col-12"> 
        <div class="mycard mt-2 position-relative overflow-hidden">
          <div className="d-flex align-items-center mb-0">
            <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Activities</h6>
          </div>
          <Line3 linename1="Savings" linename2="Distribution" linename3="Loan" label={chartData.labels} linedata1={savingsChartData.data} linedata2={distributionChartData.data} linedata3={chartData.data}/>
        </div>
      </div>
      <div className="col-12">
        <div className="mycard mt-2">
          <div className="d-flex align-items-center mb-4">
            <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Saving Records</h6>
          </div>
          <div className="table-responsive">
            <table className="table table-borderless table-dark align-middle">
              <thead>
                <tr className="fs-7">
                  <th className="fw-normal text-light">Reference</th>
                  <th className="fw-normal text-light">Type</th>
                  <th className="fw-normal text-light">Date</th>
                  <th className="fw-normal text-light">Description</th>
                  <th className="fw-normal text-light">Method</th>
                  <th className="fw-normal text-light">Amount</th>
                  <th className="fw-normal text-light">Status</th>
                </tr>
              </thead>
              <tbody style={{fontSize: '14px'}}>
                {allSavings.length > 0 ? (
                  allSavings.map((history) => (
                  <tr>
                    <td>#{history.reference}</td>
                    <td className="text-nowrap">{(history?.type || '').toString().replace(/[_-]+/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}</td>
                    <td className="text-nowrap">{history.date}</td>
                    <td className="text-nowrap">{history.description}</td>
                    <td className="text-nowrap">
                      <span className="text-nowrap ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{history.method}</span>
                    </td>
                    <td className="fw-semibold text-nowrap"><img src={history.logo} className="me-1" alt="Asset" style={{width: '25px'}}/> {Number(history.amount).toFixed(6)}</td>
                    <td><span className={`${history.status === 'pending' ? 'status-warning' : history.status === 'failed' ? 'status-danger' : 'status-success'}`}>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</span></td>
                  </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>No saving records yet.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Personal togglePersonalBar={togglePersonalBar} personalBar={personalBar}/>
    </div>
  ); 
}
export default BalanceOverview;
